import BulkModifyStakeholdersModal from './bulk-modify-stakeholders-modal';

export default BulkModifyStakeholdersModal;
